import * as React from 'react';
import EfImg from '@elem/ui/ef-img';
import { createPortal } from 'react-dom';
import EfLink from '@elem/ui/ef-link';
import styled from './index.module.scss';
import LeaderBoardModal from './LeaderBoardModal';
import DialogTerm from './DialogTerm';
import ReferModal from './ReferModal';
import { getIsLogin } from '@/utils/cookie';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';
import { useGlobal } from '@/utils/useGlobal';
import { getCurrentPlan } from '@/service/referral';
import gtm from '@/utils/gtm';

import { useMembersStore } from '@/components/MembersDay/MembersProvider';
import { set } from 'lodash';

const { useState, useEffect } = React;

const Referral = () => {
    const { t } = useLang('membersday.referral');
    const { useRouter } = useGlobal();
    const router = useRouter();
    const { locale } = getLocal();

    const [isLogin, setIsLogin] = useState(false);
    const [isClient, setIsClient] = useState(false);
    const [showDialog, setShowDialog] = useState(false);
    const [showReferModal, setShowReferModal] = useState(false);
    const [showVLBModal, setShowVLBModal] = useState(false);

    const [isHasRefer, setIsHasRefer] = useState(false);

    // const [planData, setPlanData] = useState<ICurrentPlanInfo | null>(null);
    const { referralInfo: planData, campaignInfo } = useMembersStore();

    // const initialPlan = React.useCallback(async () => {
    //     try {
    //         const plan = await getCurrentPlan(locale, `/${locale}/referral`);
    //         if (plan.code !== '0') {
    //             message.error(plan.message);
    //             return;
    //         }
    //         if (!plan.data?.planId) return;
    //         setPlanData(plan.data);
    //     } catch (error) {
    //         message.error('Failed to fetch plan data');
    //     }
    // }, [locale]);

    const handleLogin = React.useCallback(
        (hash: string, isNeeded?: boolean) => {
            if (isNeeded) {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'share',
                    list_name: 'Share the Power with Friends',
                    button_name: t('join_now'),
                });
            }
            const currentUrl = window.location.href;
            const url = new URL(currentUrl);
            url.hash = hash ? hash : '';
            router.push(`/login?redirect=${encodeURIComponent(url.href)}`);
        },
        [router, t],
    );

    const openModal = () => {
        if (isReferBtnDisabled) return;
        setShowReferModal(true);
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_button',
                position: 'banner_1',
                button_name: t('refer_now'),
            });
        } catch (e) {
            console.error(e);
        }
    };

    const openLeaderBoardModal = () => {
        setShowVLBModal(true);
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_button',
                list_name: t('title'),
                button_name: t('leaderboard'),
                function: 'Leaderboard Popup',
            });
        } catch (e) {
            console.error(e);
        }
    };

    const renderModals = () => {
        if (!isClient) return null;

        return (
            <>
                {showDialog && createPortal(<DialogTerm callback={() => setShowDialog(false)} />, document.body)}
                {showVLBModal && <LeaderBoardModal planId={planData?.planId} callback={() => setShowVLBModal(false)} />}
                {showReferModal && <ReferModal planData={planData} callback={() => setShowReferModal(false)} />}
            </>
        );
    };

    const isReferBtnDisabled = React.useMemo(() => isLogin && !isHasRefer, [isLogin, isHasRefer]);

    useEffect(() => {
        setIsLogin(getIsLogin());
        setIsClient(true);

        const isFirstModal = () => {
            const hash = window.location.hash;
            if (hash === '#referral-modal') {
                setShowVLBModal(true);
            }

            if (hash === '#referral-share') {
                setShowReferModal(true);
            }
        };

        if (typeof window !== 'undefined') {
            isFirstModal();
        }

        getCurrentPlan(locale, `/${locale}/members-festival`).then((res: any) => {
            if (res.code !== '0' || !res.data) return;
            setIsHasRefer(true);
        });
    }, []);

    // useEffect(() => {
    //     initialPlan();
    // }, [initialPlan]);

    return (
        <div className={styled.Referral} id="referral">
            <div className="members-day-title">{t('title')}</div>
            <div className="members-day-sub-title">{t('desc')}</div>
            <div id={'referral-modal'} style={{ opacity: '0' }}></div>
            <div id={'referral-share'} style={{ opacity: '0' }}></div>
            <div className="fy2025-referral-container">
                <div className="item-img">
                    <EfImg
                        pc="https://websiteoss.ecoflow.com/upload/image/1742798395605/bg_pc.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1742816794794/bg_pad.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1742798401342/bg_h5.jpg"
                    />
                </div>
                <div className="text-content">
                    <div className="desc">{t('card_desc')}</div>
                    <div className="bottom-action">
                        <div
                            className={`text-button ${isReferBtnDisabled ? 'text-button-disabled' : ''}`}
                            onClick={() => {
                                isLogin ? openModal() : handleLogin('referral-share', true);
                            }}
                        >
                            {t(isLogin ? 'refer_now' : 'join_now')}
                        </div>
                        <EfLink
                            className="text-link"
                            onClick={() => {
                                setShowDialog(true);
                            }}
                        >
                            {t('terms')}
                        </EfLink>
                        <EfLink
                            className="text-link"
                            onClick={() => {
                                isLogin ? openLeaderBoardModal() : handleLogin('referral-modal');
                            }}
                        >
                            {t('leaderboard')}
                        </EfLink>
                    </div>
                </div>
            </div>
            {renderModals()}
        </div>
    );
};

export default Referral;
